import React from "react";
import { Badge } from "react-bootstrap";

const OrderProductPackingStatus = ({ status }) => {
  if (status === "ok" || !status) {
    return null;
  }

  let status_map = {
    "expiration-date": "DLC dépassée",
    missing: "Absent",
    damaged: "Abîmé",
    "short-expiration-date": "DLC courte",
  };

  return (
    <Badge variant="danger">
      {status in status_map ? status_map[status] : status}
    </Badge>
  );
};

export default OrderProductPackingStatus;
